<ng-container *transloco="let t; read: 'objectsModule.reader-group'">
  <lib-base-panel
    [title]="t('title')"
    (onClose)="emitClose()"
    (onSave)="emitSave()"
    [menuItems]="menuItems"
    [contentTemplate]="contentTemplate"
  >
  </lib-base-panel>

  <ng-template #contentTemplate let-idx>
    <ng-container *ngIf="idx === 1" [formGroup]="formGroup">
      <div class="col">
        <app-use-check
          [formGroup]="formGroup"
          [formUseControlName]="'useIsCardReader'"
          [formValueControlName]="'isCardReader'"
          [label]="t('isCardReader')"
        ></app-use-check>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
